import { Helmet } from "react-helmet-async";

// Per-route <title>, description and canonical. Googlebot renders JS and picks
// these up, replacing the static defaults in index.html.
export function Seo({ title, description, path = "/", noindex = false, keywords = "" }) {
  return (
    <Helmet>
      <title>{title}</title>
      {description ? <meta name="description" content={description} /> : null}
      {keywords ? <meta name="keywords" content={keywords} /> : null}
      {noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <link rel="canonical" href={`https://saebit.ai${path}`} />
      )}
    </Helmet>
  );
}
